import { isRecord, str, trimmed, truncate, verbatim } from "./tool-input/index";

/** Defensive readers for a tool call's `input`, which is typed `unknown`. */
export const toolInput = { isRecord, str, trimmed, truncate, verbatim };
